module.exports = __webpack_public_path__ + "img/section5Logo1.9171c8f9.svg";